import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  /** ダイアログが開いているか */
  opened: boolean
  /** 閉じる時のコールバック */
  onClose: () => void
  /** モーダル表示中に body スクロールをロックするか（Storybook 等では false） */
  scrollLock?: boolean
  /**
   * 本文の上書き（#3414）。未指定時は従来文言（spot.ticket_required.message）。
   * スタンプ獲得の文脈で出す場合に「スタンプを獲得するには〜」へ差し替えるために使う。
   */
  message?: string
}

/**
 * 未購入（チケット/コース未購入）であることを通知する確認ダイアログ。
 * 購入導線は持たず、購入が必要な旨を通知して閉じるだけ。
 */
export const DialogTicketRequired = memo(({ opened, onClose, scrollLock = true, message }: Props) => {
  const { t } = useTranslation()
  return (
    <Dialog
      selectorState={opened}
      title={t('spot.ticket_required.title', '確認')}
      closeAction={onClose}
      lockScroll={scrollLock}
    >
      <div className="flex flex-col gap-4">
        <p className="text-center text-[14px] text-black leading-[22px]">
          {message ?? t('spot.ticket_required.message', '確認するにはチケット購入またはコース購入が必要になります')}
        </p>
        <Button label={t('common.close', '閉じる')} variant="primary" size="md" fullWidth onClick={onClose} />
      </div>
    </Dialog>
  )
})
DialogTicketRequired.displayName = 'DialogTicketRequired'
